// extracted by mini-css-extract-plugin
module.exports = {"container":"PreferencesPrivatePage_container__2fOO2","alert":"PreferencesPrivatePage_alert__2PIdB"};